import {
    httpGetPlannedAccessTypes,
    HttpGetPlannedAccessTypesOptions,
    HttpGetPlannedAccessTypesResponse
} from '@/features/planned-accesses/http/plannedAccesses.http'
import {QUERY_KEYS} from '@/queryClient'
import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query'

interface UseGetPlannedAccessTypesOptions {
    urlParams: HttpGetPlannedAccessTypesOptions['urlParams']
    params: HttpGetPlannedAccessTypesOptions['params']
    options?: Pick<UseInfiniteQueryOptions<HttpGetPlannedAccessTypesResponse>, 'enabled'>
}

export const useGetPlannedAccessTypes = ({urlParams, params, options}: UseGetPlannedAccessTypesOptions) => {
    return useInfiniteQuery({
        queryKey: [QUERY_KEYS.PLANNED_ACCESSES, urlParams.projectId, params],
        queryFn: ({pageParam = 1}) =>
            httpGetPlannedAccessTypes({
                urlParams,
                params: {...params, page: pageParam}
            }),
        ...options,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })
}
